import { inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, take } from 'rxjs';
import { ApiService, userHasPassword } from '@cue/api';
import { AppState, currentUser } from '@assist/shared/data';

export function injectHasPassword() {
  const store = inject<Store<AppState>>(Store<AppState>);
  const apiService = inject(ApiService);
  return rxResource({
    stream: () =>
      store.select(currentUser).pipe(
        filter((userResponse) => !userResponse.loading && !!userResponse.data?.email),
        take(1),
        switchMap((userResponse) => apiService.call(userHasPassword({ email: userResponse.data.email }))),
        map((response) => response.success && response.data?.hasPassword === true)
      ),
  });
}
